/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateTenantRestrictionsOptions,
  UpdateTenantRestrictionsResponses,
} from '../types/UpdateTenantRestrictions'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update tenant restrictions by ID.
 * {@link /v1/tenants/:tenant_id/restrictions}
 */
export function updateTenantRestrictions<ThrowOnError extends boolean = true>(
  options: Options<UpdateTenantRestrictionsOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateTenantRestrictionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/tenants/{tenant_id}/restrictions',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateTenantRestrictionsResponses, ThrowOnError>>,
  )
}
